var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5006 18.6261C13.5006 20.1412 15.8962 20.7778 15.8962 20.7778H6.23438C6.23438 20.7778 8.62996 20.1412 8.62996 18.6261V17.1187H13.4512L13.5006 18.6261Z",
    fill: "#8139D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3094 17.1111H2.82108C1.96473 17.1111 1.27051 16.4169 1.27051 15.5605V4.89896C1.27051 4.04261 1.96473 3.34839 2.82108 3.34839H19.3094C20.1658 3.34839 20.86 4.04261 20.86 4.89896V15.5605C20.86 16.4169 20.1658 17.1111 19.3094 17.1111Z",
    fill: "#F1B31C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6396 14.2759L1.2876 7.39459V4.50477C1.2876 3.94087 1.84585 3.54685 2.37718 3.73578L20.6396 10.2297V14.2759Z",
    fill: "#FCEA2B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.86 14.5331C20.86 14.5331 20.9688 15.4688 20.6251 16.1563C20.2114 17.1101 19.5373 17.1106 19.2685 17.1101H2.82108C1.96473 17.1101 1.54875 16.5442 1.54875 16.3635C1.54875 16.3635 1.27051 16.1563 1.27051 15.5769C1.27051 15.1693 1.27051 14.5331 1.27051 14.5331",
    fill: "#C6AAFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkLogo);
export default __webpack_public_path__ + "static/media/work-logo.c8044dcc7c23a7d158489f4022b8c11b.svg";
export { ForwardRef as ReactComponent };